export const coupons = [
  {
    title: 500,
    id: 1,
    img: "/img/500usd.png",
    category: "500 USD",
  },
  {
    title: 1000,
    id: 2,
    img: "/img/1000usd.png",
    category: "1000 USD",
  },
  {
    title: 1500,
    id: 3,
    img: "/img/1500usd.png",
    category: "1500 USD",
  },
];
